//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class BoostWishClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculate(body: BoostWishInput | undefined): Promise<BoostWishCalculateResult> {
        let url_ = this.baseUrl + "/boost-wish/Calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<BoostWishCalculateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoostWishCalculateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoostWishCalculateResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    optimize(body: BoostWishInput | undefined): Promise<BoostWishOptimizeResult> {
        let url_ = this.baseUrl + "/boost-wish/Optimize";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processOptimize(_response);
        });
    }

    protected processOptimize(response: Response): Promise<BoostWishOptimizeResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BoostWishOptimizeResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BoostWishOptimizeResult>(null as any);
    }
}

export class DisableListClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getInfo(): Promise<DisableListInfoDto> {
        let url_ = this.baseUrl + "/disable-list/GetInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetInfo(_response);
        });
    }

    protected processGetInfo(response: Response): Promise<DisableListInfoDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListInfoDto.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    getToggles(): Promise<DisableListToggleDto[]> {
        let url_ = this.baseUrl + "/disable-list/GetToggles";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGetToggles(_response);
        });
    }

    protected processGetToggles(response: Response): Promise<DisableListToggleDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DisableListToggleDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListToggleDto[]>(null as any);
    }

    /**
     * @param text (optional) 
     * @param cacheKey (optional) 
     * @return Success
     */
    searchSeries(text: string | undefined, cacheKey: number | undefined): Promise<DisableListItemBasicDto[]> {
        let url_ = this.baseUrl + "/disable-list/SearchSeries?";
        if (text === null)
            throw new Error("The parameter 'text' cannot be null.");
        else if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (cacheKey === null)
            throw new Error("The parameter 'cacheKey' cannot be null.");
        else if (cacheKey !== undefined)
            url_ += "cacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchSeries(_response);
        });
    }

    protected processSearchSeries(response: Response): Promise<DisableListItemBasicDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DisableListItemBasicDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListItemBasicDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSearchSeries(body: DisableListTextSearchInput | undefined): Promise<DisableListSeriesSearchResult> {
        let url_ = this.baseUrl + "/disable-list/BulkSearchSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkSearchSeries(_response);
        });
    }

    protected processBulkSearchSeries(response: Response): Promise<DisableListSeriesSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListSeriesSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListSeriesSearchResult>(null as any);
    }

    /**
     * @param text (optional) 
     * @param cacheKey (optional) 
     * @return Success
     */
    searchCharacters(text: string | undefined, cacheKey: number | undefined): Promise<DisableListCharacterDto[]> {
        let url_ = this.baseUrl + "/disable-list/SearchCharacters?";
        if (text === null)
            throw new Error("The parameter 'text' cannot be null.");
        else if (text !== undefined)
            url_ += "text=" + encodeURIComponent("" + text) + "&";
        if (cacheKey === null)
            throw new Error("The parameter 'cacheKey' cannot be null.");
        else if (cacheKey !== undefined)
            url_ += "cacheKey=" + encodeURIComponent("" + cacheKey) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearchCharacters(_response);
        });
    }

    protected processSearchCharacters(response: Response): Promise<DisableListCharacterDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DisableListCharacterDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListCharacterDto[]>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSearchCharacters(body: DisableListTextSearchInput | undefined): Promise<DisableListCharacterSearchResult> {
        let url_ = this.baseUrl + "/disable-list/BulkSearchCharacters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkSearchCharacters(_response);
        });
    }

    protected processBulkSearchCharacters(response: Response): Promise<DisableListCharacterSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListCharacterSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListCharacterSearchResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    bulkSearchBundlesAndSeries(body: DisableListTextSearchInput | undefined): Promise<DisableListBundleAndSeriesSearchResult> {
        let url_ = this.baseUrl + "/disable-list/BulkSearchBundlesAndSeries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processBulkSearchBundlesAndSeries(_response);
        });
    }

    protected processBulkSearchBundlesAndSeries(response: Response): Promise<DisableListBundleAndSeriesSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListBundleAndSeriesSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListBundleAndSeriesSearchResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    search(body: DisableListSearchInput | undefined): Promise<DisableListSearchResult> {
        let url_ = this.baseUrl + "/disable-list/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processSearch(_response);
        });
    }

    protected processSearch(response: Response): Promise<DisableListSearchResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListSearchResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListSearchResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    check(body: DisableListCheckInput | undefined): Promise<DisableListCheckResult> {
        let url_ = this.baseUrl + "/disable-list/Check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCheck(_response);
        });
    }

    protected processCheck(response: Response): Promise<DisableListCheckResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListCheckResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListCheckResult>(null as any);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generate(body: DisableListGenerateInput | undefined): Promise<DisableListGenerateResult> {
        let url_ = this.baseUrl + "/disable-list/Generate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processGenerate(_response);
        });
    }

    protected processGenerate(response: Response): Promise<DisableListGenerateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DisableListGenerateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DisableListGenerateResult>(null as any);
    }
}

export class KakeraLootsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    calculate(body: KakeraLootsInput | undefined): Promise<KakeraLootsCalculateResult> {
        let url_ = this.baseUrl + "/kakera-loots/Calculate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processCalculate(_response);
        });
    }

    protected processCalculate(response: Response): Promise<KakeraLootsCalculateResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = KakeraLootsCalculateResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<KakeraLootsCalculateResult>(null as any);
    }
}

export class UtilityClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    formatList(body: FormatListInput | undefined): Promise<FormatListResult> {
        let url_ = this.baseUrl + "/utility/FormatList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.processFormatList(_response);
        });
    }

    protected processFormatList(response: Response): Promise<FormatListResult> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormatListResult.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormatListResult>(null as any);
    }
}

export class BoostWishCalculateResult implements IBoostWishCalculateResult {
    hourlyRolls?: number;
    ownedStarWishRolls?: string | undefined;
    unclaimedStarWishRolls?: string | undefined;
    claimedStarWishRolls?: string | undefined;
    ownedWishRolls?: string | undefined;
    unclaimedWishRolls?: string | undefined;
    claimedWishRolls?: string | undefined;
    ownedNormalRolls?: string | undefined;
    unclaimedNormalRolls?: string | undefined;
    claimedNormalRolls?: string | undefined;

    constructor(data?: IBoostWishCalculateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyRolls = _data["hourlyRolls"];
            this.ownedStarWishRolls = _data["ownedStarWishRolls"];
            this.unclaimedStarWishRolls = _data["unclaimedStarWishRolls"];
            this.claimedStarWishRolls = _data["claimedStarWishRolls"];
            this.ownedWishRolls = _data["ownedWishRolls"];
            this.unclaimedWishRolls = _data["unclaimedWishRolls"];
            this.claimedWishRolls = _data["claimedWishRolls"];
            this.ownedNormalRolls = _data["ownedNormalRolls"];
            this.unclaimedNormalRolls = _data["unclaimedNormalRolls"];
            this.claimedNormalRolls = _data["claimedNormalRolls"];
        }
    }

    static fromJS(data: any): BoostWishCalculateResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoostWishCalculateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyRolls"] = this.hourlyRolls;
        data["ownedStarWishRolls"] = this.ownedStarWishRolls;
        data["unclaimedStarWishRolls"] = this.unclaimedStarWishRolls;
        data["claimedStarWishRolls"] = this.claimedStarWishRolls;
        data["ownedWishRolls"] = this.ownedWishRolls;
        data["unclaimedWishRolls"] = this.unclaimedWishRolls;
        data["claimedWishRolls"] = this.claimedWishRolls;
        data["ownedNormalRolls"] = this.ownedNormalRolls;
        data["unclaimedNormalRolls"] = this.unclaimedNormalRolls;
        data["claimedNormalRolls"] = this.claimedNormalRolls;
        return data;
    }
}

export interface IBoostWishCalculateResult {
    hourlyRolls?: number;
    ownedStarWishRolls?: string | undefined;
    unclaimedStarWishRolls?: string | undefined;
    claimedStarWishRolls?: string | undefined;
    ownedWishRolls?: string | undefined;
    unclaimedWishRolls?: string | undefined;
    claimedWishRolls?: string | undefined;
    ownedNormalRolls?: string | undefined;
    unclaimedNormalRolls?: string | undefined;
    claimedNormalRolls?: string | undefined;
}

export class BoostWishInput implements IBoostWishInput {
    optimizationMode?: BoostWishOptimizationMode;
    baseRolls?: number;
    bonusRolls?: number;
    boostWishRolls?: number;
    boostKakeraRolls?: number;
    maxAllowedRolls?: number | undefined;
    starWishBonus?: number;
    wishBonus?: number;
    persrare?: number;
    doubleKeyRate?: number | undefined;
    ownedStarWishCount?: number;
    unclaimedStarWishCount?: number;
    claimedStarWishCount?: number;
    ownedWishCount?: number;
    unclaimedWishCount?: number;
    claimedWishCount?: number;
    ownedNormalCount?: number;
    unclaimedNormalCount?: number;
    claimedNormalCount?: number;
    totalCount?: number;

    constructor(data?: IBoostWishInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.optimizationMode = _data["optimizationMode"];
            this.baseRolls = _data["baseRolls"];
            this.bonusRolls = _data["bonusRolls"];
            this.boostWishRolls = _data["boostWishRolls"];
            this.boostKakeraRolls = _data["boostKakeraRolls"];
            this.maxAllowedRolls = _data["maxAllowedRolls"];
            this.starWishBonus = _data["starWishBonus"];
            this.wishBonus = _data["wishBonus"];
            this.persrare = _data["persrare"];
            this.doubleKeyRate = _data["doubleKeyRate"];
            this.ownedStarWishCount = _data["ownedStarWishCount"];
            this.unclaimedStarWishCount = _data["unclaimedStarWishCount"];
            this.claimedStarWishCount = _data["claimedStarWishCount"];
            this.ownedWishCount = _data["ownedWishCount"];
            this.unclaimedWishCount = _data["unclaimedWishCount"];
            this.claimedWishCount = _data["claimedWishCount"];
            this.ownedNormalCount = _data["ownedNormalCount"];
            this.unclaimedNormalCount = _data["unclaimedNormalCount"];
            this.claimedNormalCount = _data["claimedNormalCount"];
            this.totalCount = _data["totalCount"];
        }
    }

    static fromJS(data: any): BoostWishInput {
        data = typeof data === 'object' ? data : {};
        let result = new BoostWishInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["optimizationMode"] = this.optimizationMode;
        data["baseRolls"] = this.baseRolls;
        data["bonusRolls"] = this.bonusRolls;
        data["boostWishRolls"] = this.boostWishRolls;
        data["boostKakeraRolls"] = this.boostKakeraRolls;
        data["maxAllowedRolls"] = this.maxAllowedRolls;
        data["starWishBonus"] = this.starWishBonus;
        data["wishBonus"] = this.wishBonus;
        data["persrare"] = this.persrare;
        data["doubleKeyRate"] = this.doubleKeyRate;
        data["ownedStarWishCount"] = this.ownedStarWishCount;
        data["unclaimedStarWishCount"] = this.unclaimedStarWishCount;
        data["claimedStarWishCount"] = this.claimedStarWishCount;
        data["ownedWishCount"] = this.ownedWishCount;
        data["unclaimedWishCount"] = this.unclaimedWishCount;
        data["claimedWishCount"] = this.claimedWishCount;
        data["ownedNormalCount"] = this.ownedNormalCount;
        data["unclaimedNormalCount"] = this.unclaimedNormalCount;
        data["claimedNormalCount"] = this.claimedNormalCount;
        data["totalCount"] = this.totalCount;
        return data;
    }
}

export interface IBoostWishInput {
    optimizationMode?: BoostWishOptimizationMode;
    baseRolls?: number;
    bonusRolls?: number;
    boostWishRolls?: number;
    boostKakeraRolls?: number;
    maxAllowedRolls?: number | undefined;
    starWishBonus?: number;
    wishBonus?: number;
    persrare?: number;
    doubleKeyRate?: number | undefined;
    ownedStarWishCount?: number;
    unclaimedStarWishCount?: number;
    claimedStarWishCount?: number;
    ownedWishCount?: number;
    unclaimedWishCount?: number;
    claimedWishCount?: number;
    ownedNormalCount?: number;
    unclaimedNormalCount?: number;
    claimedNormalCount?: number;
    totalCount?: number;
}

export enum BoostWishOptimizationMode {
    WishKeys = 0,
    AllKeys = 1,
    UnclaimedWish = 2,
}

export class BoostWishOptimizeResult implements IBoostWishOptimizeResult {
    hourlyRolls?: number;
    ownedStarWishRolls?: string | undefined;
    unclaimedStarWishRolls?: string | undefined;
    claimedStarWishRolls?: string | undefined;
    ownedWishRolls?: string | undefined;
    unclaimedWishRolls?: string | undefined;
    claimedWishRolls?: string | undefined;
    ownedNormalRolls?: string | undefined;
    unclaimedNormalRolls?: string | undefined;
    claimedNormalRolls?: string | undefined;
    boostWishRolls?: number;
    starWishKeys?: string | undefined;
    ownedWishKeys?: string | undefined;
    ownedNormalKeys?: string | undefined;

    constructor(data?: IBoostWishOptimizeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hourlyRolls = _data["hourlyRolls"];
            this.ownedStarWishRolls = _data["ownedStarWishRolls"];
            this.unclaimedStarWishRolls = _data["unclaimedStarWishRolls"];
            this.claimedStarWishRolls = _data["claimedStarWishRolls"];
            this.ownedWishRolls = _data["ownedWishRolls"];
            this.unclaimedWishRolls = _data["unclaimedWishRolls"];
            this.claimedWishRolls = _data["claimedWishRolls"];
            this.ownedNormalRolls = _data["ownedNormalRolls"];
            this.unclaimedNormalRolls = _data["unclaimedNormalRolls"];
            this.claimedNormalRolls = _data["claimedNormalRolls"];
            this.boostWishRolls = _data["boostWishRolls"];
            this.starWishKeys = _data["starWishKeys"];
            this.ownedWishKeys = _data["ownedWishKeys"];
            this.ownedNormalKeys = _data["ownedNormalKeys"];
        }
    }

    static fromJS(data: any): BoostWishOptimizeResult {
        data = typeof data === 'object' ? data : {};
        let result = new BoostWishOptimizeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hourlyRolls"] = this.hourlyRolls;
        data["ownedStarWishRolls"] = this.ownedStarWishRolls;
        data["unclaimedStarWishRolls"] = this.unclaimedStarWishRolls;
        data["claimedStarWishRolls"] = this.claimedStarWishRolls;
        data["ownedWishRolls"] = this.ownedWishRolls;
        data["unclaimedWishRolls"] = this.unclaimedWishRolls;
        data["claimedWishRolls"] = this.claimedWishRolls;
        data["ownedNormalRolls"] = this.ownedNormalRolls;
        data["unclaimedNormalRolls"] = this.unclaimedNormalRolls;
        data["claimedNormalRolls"] = this.claimedNormalRolls;
        data["boostWishRolls"] = this.boostWishRolls;
        data["starWishKeys"] = this.starWishKeys;
        data["ownedWishKeys"] = this.ownedWishKeys;
        data["ownedNormalKeys"] = this.ownedNormalKeys;
        return data;
    }
}

export interface IBoostWishOptimizeResult {
    hourlyRolls?: number;
    ownedStarWishRolls?: string | undefined;
    unclaimedStarWishRolls?: string | undefined;
    claimedStarWishRolls?: string | undefined;
    ownedWishRolls?: string | undefined;
    unclaimedWishRolls?: string | undefined;
    claimedWishRolls?: string | undefined;
    ownedNormalRolls?: string | undefined;
    unclaimedNormalRolls?: string | undefined;
    claimedNormalRolls?: string | undefined;
    boostWishRolls?: number;
    starWishKeys?: string | undefined;
    ownedWishKeys?: string | undefined;
    ownedNormalKeys?: string | undefined;
}

export class DisableListBundleAndSeriesSearchResult implements IDisableListBundleAndSeriesSearchResult {
    bundles?: DisableListItemBasicDto[] | undefined;
    series?: DisableListItemBasicDto[] | undefined;
    notFound?: string[] | undefined;

    constructor(data?: IDisableListBundleAndSeriesSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["bundles"])) {
                this.bundles = [] as any;
                for (let item of _data["bundles"])
                    this.bundles!.push(DisableListItemBasicDto.fromJS(item));
            }
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(DisableListItemBasicDto.fromJS(item));
            }
            if (Array.isArray(_data["notFound"])) {
                this.notFound = [] as any;
                for (let item of _data["notFound"])
                    this.notFound!.push(item);
            }
        }
    }

    static fromJS(data: any): DisableListBundleAndSeriesSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListBundleAndSeriesSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.bundles)) {
            data["bundles"] = [];
            for (let item of this.bundles)
                data["bundles"].push(item.toJSON());
        }
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        if (Array.isArray(this.notFound)) {
            data["notFound"] = [];
            for (let item of this.notFound)
                data["notFound"].push(item);
        }
        return data;
    }
}

export interface IDisableListBundleAndSeriesSearchResult {
    bundles?: DisableListItemBasicDto[] | undefined;
    series?: DisableListItemBasicDto[] | undefined;
    notFound?: string[] | undefined;
}

export class DisableListCharacterDto implements IDisableListCharacterDto {
    id?: number;
    name?: string | undefined;
    seriesName?: string | undefined;
    isWa?: boolean;
    isHa?: boolean;
    isWg?: boolean;
    isHg?: boolean;

    constructor(data?: IDisableListCharacterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.seriesName = _data["seriesName"];
            this.isWa = _data["isWa"];
            this.isHa = _data["isHa"];
            this.isWg = _data["isWg"];
            this.isHg = _data["isHg"];
        }
    }

    static fromJS(data: any): DisableListCharacterDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListCharacterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["seriesName"] = this.seriesName;
        data["isWa"] = this.isWa;
        data["isHa"] = this.isHa;
        data["isWg"] = this.isWg;
        data["isHg"] = this.isHg;
        return data;
    }
}

export interface IDisableListCharacterDto {
    id?: number;
    name?: string | undefined;
    seriesName?: string | undefined;
    isWa?: boolean;
    isHa?: boolean;
    isWg?: boolean;
    isHg?: boolean;
}

export class DisableListCharacterSearchResult implements IDisableListCharacterSearchResult {
    characters?: DisableListCharacterDto[] | undefined;
    notFound?: string[] | undefined;

    constructor(data?: IDisableListCharacterSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["characters"])) {
                this.characters = [] as any;
                for (let item of _data["characters"])
                    this.characters!.push(DisableListCharacterDto.fromJS(item));
            }
            if (Array.isArray(_data["notFound"])) {
                this.notFound = [] as any;
                for (let item of _data["notFound"])
                    this.notFound!.push(item);
            }
        }
    }

    static fromJS(data: any): DisableListCharacterSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListCharacterSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.characters)) {
            data["characters"] = [];
            for (let item of this.characters)
                data["characters"].push(item.toJSON());
        }
        if (Array.isArray(this.notFound)) {
            data["notFound"] = [];
            for (let item of this.notFound)
                data["notFound"].push(item);
        }
        return data;
    }
}

export interface IDisableListCharacterSearchResult {
    characters?: DisableListCharacterDto[] | undefined;
    notFound?: string[] | undefined;
}

export class DisableListCheckInput implements IDisableListCheckInput {
    cacheKey?: number | undefined;
    antiDisableIds?: number[] | undefined;
    serverDisableIds?: number[] | undefined;
    toggleIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    bundleIds?: number[] | undefined;
    seriesIds?: number[] | undefined;
    roulette?: DisableListRoulette;
    sortColumn?: DisableListSortColumn;
    sortDirection?: DisableListSortDirection;

    constructor(data?: IDisableListCheckInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheKey = _data["cacheKey"];
            if (Array.isArray(_data["antiDisableIds"])) {
                this.antiDisableIds = [] as any;
                for (let item of _data["antiDisableIds"])
                    this.antiDisableIds!.push(item);
            }
            if (Array.isArray(_data["serverDisableIds"])) {
                this.serverDisableIds = [] as any;
                for (let item of _data["serverDisableIds"])
                    this.serverDisableIds!.push(item);
            }
            if (Array.isArray(_data["toggleIds"])) {
                this.toggleIds = [] as any;
                for (let item of _data["toggleIds"])
                    this.toggleIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["bundleIds"])) {
                this.bundleIds = [] as any;
                for (let item of _data["bundleIds"])
                    this.bundleIds!.push(item);
            }
            if (Array.isArray(_data["seriesIds"])) {
                this.seriesIds = [] as any;
                for (let item of _data["seriesIds"])
                    this.seriesIds!.push(item);
            }
            this.roulette = _data["roulette"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): DisableListCheckInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListCheckInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheKey"] = this.cacheKey;
        if (Array.isArray(this.antiDisableIds)) {
            data["antiDisableIds"] = [];
            for (let item of this.antiDisableIds)
                data["antiDisableIds"].push(item);
        }
        if (Array.isArray(this.serverDisableIds)) {
            data["serverDisableIds"] = [];
            for (let item of this.serverDisableIds)
                data["serverDisableIds"].push(item);
        }
        if (Array.isArray(this.toggleIds)) {
            data["toggleIds"] = [];
            for (let item of this.toggleIds)
                data["toggleIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.bundleIds)) {
            data["bundleIds"] = [];
            for (let item of this.bundleIds)
                data["bundleIds"].push(item);
        }
        if (Array.isArray(this.seriesIds)) {
            data["seriesIds"] = [];
            for (let item of this.seriesIds)
                data["seriesIds"].push(item);
        }
        data["roulette"] = this.roulette;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IDisableListCheckInput {
    cacheKey?: number | undefined;
    antiDisableIds?: number[] | undefined;
    serverDisableIds?: number[] | undefined;
    toggleIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    bundleIds?: number[] | undefined;
    seriesIds?: number[] | undefined;
    roulette?: DisableListRoulette;
    sortColumn?: DisableListSortColumn;
    sortDirection?: DisableListSortDirection;
}

export class DisableListCheckResult implements IDisableListCheckResult {
    totals?: DisableListTotalsDto;
    items?: DisableListItemDto[] | undefined;

    constructor(data?: IDisableListCheckResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totals = _data["totals"] ? DisableListTotalsDto.fromJS(_data["totals"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DisableListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DisableListCheckResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListCheckResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDisableListCheckResult {
    totals?: DisableListTotalsDto;
    items?: DisableListItemDto[] | undefined;
}

export class DisableListGenerateInput implements IDisableListGenerateInput {
    roulette?: DisableListRoulette;
    slots?: number;
    overlap?: number;
    toggleIds?: number[] | undefined;

    constructor(data?: IDisableListGenerateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roulette = _data["roulette"];
            this.slots = _data["slots"];
            this.overlap = _data["overlap"];
            if (Array.isArray(_data["toggleIds"])) {
                this.toggleIds = [] as any;
                for (let item of _data["toggleIds"])
                    this.toggleIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DisableListGenerateInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListGenerateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roulette"] = this.roulette;
        data["slots"] = this.slots;
        data["overlap"] = this.overlap;
        if (Array.isArray(this.toggleIds)) {
            data["toggleIds"] = [];
            for (let item of this.toggleIds)
                data["toggleIds"].push(item);
        }
        return data;
    }
}

export interface IDisableListGenerateInput {
    roulette?: DisableListRoulette;
    slots?: number;
    overlap?: number;
    toggleIds?: number[] | undefined;
}

export class DisableListGenerateResult implements IDisableListGenerateResult {
    slots?: number;
    maxSlots?: number;
    overlap?: number;
    maxOverlap?: number;
    totalCharacters?: number;
    waDisabled?: number;
    haDisabled?: number;
    wgDisabled?: number;
    hgDisabled?: number;
    items?: string[] | undefined;

    constructor(data?: IDisableListGenerateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.slots = _data["slots"];
            this.maxSlots = _data["maxSlots"];
            this.overlap = _data["overlap"];
            this.maxOverlap = _data["maxOverlap"];
            this.totalCharacters = _data["totalCharacters"];
            this.waDisabled = _data["waDisabled"];
            this.haDisabled = _data["haDisabled"];
            this.wgDisabled = _data["wgDisabled"];
            this.hgDisabled = _data["hgDisabled"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): DisableListGenerateResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListGenerateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["slots"] = this.slots;
        data["maxSlots"] = this.maxSlots;
        data["overlap"] = this.overlap;
        data["maxOverlap"] = this.maxOverlap;
        data["totalCharacters"] = this.totalCharacters;
        data["waDisabled"] = this.waDisabled;
        data["haDisabled"] = this.haDisabled;
        data["wgDisabled"] = this.wgDisabled;
        data["hgDisabled"] = this.hgDisabled;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IDisableListGenerateResult {
    slots?: number;
    maxSlots?: number;
    overlap?: number;
    maxOverlap?: number;
    totalCharacters?: number;
    waDisabled?: number;
    haDisabled?: number;
    wgDisabled?: number;
    hgDisabled?: number;
    items?: string[] | undefined;
}

export class DisableListInfoDto implements IDisableListInfoDto {
    cacheKey?: number;
    updateDateTime?: Date;
    waLimit?: number;
    haLimit?: number;
    wgLimit?: number;
    hgLimit?: number;
    toggles?: DisableListToggleDto[] | undefined;

    constructor(data?: IDisableListInfoDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheKey = _data["cacheKey"];
            this.updateDateTime = _data["updateDateTime"] ? new Date(_data["updateDateTime"].toString()) : <any>undefined;
            this.waLimit = _data["waLimit"];
            this.haLimit = _data["haLimit"];
            this.wgLimit = _data["wgLimit"];
            this.hgLimit = _data["hgLimit"];
            if (Array.isArray(_data["toggles"])) {
                this.toggles = [] as any;
                for (let item of _data["toggles"])
                    this.toggles!.push(DisableListToggleDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DisableListInfoDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListInfoDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheKey"] = this.cacheKey;
        data["updateDateTime"] = this.updateDateTime ? this.updateDateTime.toISOString() : <any>undefined;
        data["waLimit"] = this.waLimit;
        data["haLimit"] = this.haLimit;
        data["wgLimit"] = this.wgLimit;
        data["hgLimit"] = this.hgLimit;
        if (Array.isArray(this.toggles)) {
            data["toggles"] = [];
            for (let item of this.toggles)
                data["toggles"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDisableListInfoDto {
    cacheKey?: number;
    updateDateTime?: Date;
    waLimit?: number;
    haLimit?: number;
    wgLimit?: number;
    hgLimit?: number;
    toggles?: DisableListToggleDto[] | undefined;
}

export class DisableListItemBasicDto implements IDisableListItemBasicDto {
    id?: number;
    type?: DisableListItemType;
    name?: string | undefined;
    size?: number;
    numWa?: number;
    numHa?: number;
    numWg?: number;
    numHg?: number;

    constructor(data?: IDisableListItemBasicDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.size = _data["size"];
            this.numWa = _data["numWa"];
            this.numHa = _data["numHa"];
            this.numWg = _data["numWg"];
            this.numHg = _data["numHg"];
        }
    }

    static fromJS(data: any): DisableListItemBasicDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListItemBasicDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["size"] = this.size;
        data["numWa"] = this.numWa;
        data["numHa"] = this.numHa;
        data["numWg"] = this.numWg;
        data["numHg"] = this.numHg;
        return data;
    }
}

export interface IDisableListItemBasicDto {
    id?: number;
    type?: DisableListItemType;
    name?: string | undefined;
    size?: number;
    numWa?: number;
    numHa?: number;
    numWg?: number;
    numHg?: number;
}

export class DisableListItemDto implements IDisableListItemDto {
    id?: number;
    type?: DisableListItemType;
    name?: string | undefined;
    size?: number;
    totalWa?: number;
    serverDisabledWa?: number;
    antiDisabledWa?: number;
    toggleDisabledWa?: number;
    overlapDisabledWa?: number;
    actualWa?: number;
    totalHa?: number;
    serverDisabledHa?: number;
    antiDisabledHa?: number;
    toggleDisabledHa?: number;
    overlapDisabledHa?: number;
    actualHa?: number;
    totalWg?: number;
    serverDisabledWg?: number;
    antiDisabledWg?: number;
    toggleDisabledWg?: number;
    overlapDisabledWg?: number;
    actualWg?: number;
    totalHg?: number;
    serverDisabledHg?: number;
    antiDisabledHg?: number;
    toggleDisabledHg?: number;
    overlapDisabledHg?: number;
    actualHg?: number;

    constructor(data?: IDisableListItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.size = _data["size"];
            this.totalWa = _data["totalWa"];
            this.serverDisabledWa = _data["serverDisabledWa"];
            this.antiDisabledWa = _data["antiDisabledWa"];
            this.toggleDisabledWa = _data["toggleDisabledWa"];
            this.overlapDisabledWa = _data["overlapDisabledWa"];
            this.actualWa = _data["actualWa"];
            this.totalHa = _data["totalHa"];
            this.serverDisabledHa = _data["serverDisabledHa"];
            this.antiDisabledHa = _data["antiDisabledHa"];
            this.toggleDisabledHa = _data["toggleDisabledHa"];
            this.overlapDisabledHa = _data["overlapDisabledHa"];
            this.actualHa = _data["actualHa"];
            this.totalWg = _data["totalWg"];
            this.serverDisabledWg = _data["serverDisabledWg"];
            this.antiDisabledWg = _data["antiDisabledWg"];
            this.toggleDisabledWg = _data["toggleDisabledWg"];
            this.overlapDisabledWg = _data["overlapDisabledWg"];
            this.actualWg = _data["actualWg"];
            this.totalHg = _data["totalHg"];
            this.serverDisabledHg = _data["serverDisabledHg"];
            this.antiDisabledHg = _data["antiDisabledHg"];
            this.toggleDisabledHg = _data["toggleDisabledHg"];
            this.overlapDisabledHg = _data["overlapDisabledHg"];
            this.actualHg = _data["actualHg"];
        }
    }

    static fromJS(data: any): DisableListItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["size"] = this.size;
        data["totalWa"] = this.totalWa;
        data["serverDisabledWa"] = this.serverDisabledWa;
        data["antiDisabledWa"] = this.antiDisabledWa;
        data["toggleDisabledWa"] = this.toggleDisabledWa;
        data["overlapDisabledWa"] = this.overlapDisabledWa;
        data["actualWa"] = this.actualWa;
        data["totalHa"] = this.totalHa;
        data["serverDisabledHa"] = this.serverDisabledHa;
        data["antiDisabledHa"] = this.antiDisabledHa;
        data["toggleDisabledHa"] = this.toggleDisabledHa;
        data["overlapDisabledHa"] = this.overlapDisabledHa;
        data["actualHa"] = this.actualHa;
        data["totalWg"] = this.totalWg;
        data["serverDisabledWg"] = this.serverDisabledWg;
        data["antiDisabledWg"] = this.antiDisabledWg;
        data["toggleDisabledWg"] = this.toggleDisabledWg;
        data["overlapDisabledWg"] = this.overlapDisabledWg;
        data["actualWg"] = this.actualWg;
        data["totalHg"] = this.totalHg;
        data["serverDisabledHg"] = this.serverDisabledHg;
        data["antiDisabledHg"] = this.antiDisabledHg;
        data["toggleDisabledHg"] = this.toggleDisabledHg;
        data["overlapDisabledHg"] = this.overlapDisabledHg;
        data["actualHg"] = this.actualHg;
        return data;
    }
}

export interface IDisableListItemDto {
    id?: number;
    type?: DisableListItemType;
    name?: string | undefined;
    size?: number;
    totalWa?: number;
    serverDisabledWa?: number;
    antiDisabledWa?: number;
    toggleDisabledWa?: number;
    overlapDisabledWa?: number;
    actualWa?: number;
    totalHa?: number;
    serverDisabledHa?: number;
    antiDisabledHa?: number;
    toggleDisabledHa?: number;
    overlapDisabledHa?: number;
    actualHa?: number;
    totalWg?: number;
    serverDisabledWg?: number;
    antiDisabledWg?: number;
    toggleDisabledWg?: number;
    overlapDisabledWg?: number;
    actualWg?: number;
    totalHg?: number;
    serverDisabledHg?: number;
    antiDisabledHg?: number;
    toggleDisabledHg?: number;
    overlapDisabledHg?: number;
    actualHg?: number;
}

export enum DisableListItemType {
    Tag = 0,
    Bundle = 1,
    Series = 2,
}

export enum DisableListRoulette {
    Wa = 0,
    Ha = 1,
    Wg = 2,
    Hg = 3,
}

export class DisableListSearchInput implements IDisableListSearchInput {
    cacheKey?: number | undefined;
    antiDisableIds?: number[] | undefined;
    serverDisableIds?: number[] | undefined;
    toggleIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    bundleIds?: number[] | undefined;
    seriesIds?: number[] | undefined;
    name?: string | undefined;
    roulette?: DisableListRoulette;
    minEfficiency?: number;
    minDisabled?: number;
    maxResultCount?: number;
    sortColumn?: DisableListSortColumn;
    sortDirection?: DisableListSortDirection;

    constructor(data?: IDisableListSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheKey = _data["cacheKey"];
            if (Array.isArray(_data["antiDisableIds"])) {
                this.antiDisableIds = [] as any;
                for (let item of _data["antiDisableIds"])
                    this.antiDisableIds!.push(item);
            }
            if (Array.isArray(_data["serverDisableIds"])) {
                this.serverDisableIds = [] as any;
                for (let item of _data["serverDisableIds"])
                    this.serverDisableIds!.push(item);
            }
            if (Array.isArray(_data["toggleIds"])) {
                this.toggleIds = [] as any;
                for (let item of _data["toggleIds"])
                    this.toggleIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["bundleIds"])) {
                this.bundleIds = [] as any;
                for (let item of _data["bundleIds"])
                    this.bundleIds!.push(item);
            }
            if (Array.isArray(_data["seriesIds"])) {
                this.seriesIds = [] as any;
                for (let item of _data["seriesIds"])
                    this.seriesIds!.push(item);
            }
            this.name = _data["name"];
            this.roulette = _data["roulette"];
            this.minEfficiency = _data["minEfficiency"];
            this.minDisabled = _data["minDisabled"];
            this.maxResultCount = _data["maxResultCount"];
            this.sortColumn = _data["sortColumn"];
            this.sortDirection = _data["sortDirection"];
        }
    }

    static fromJS(data: any): DisableListSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheKey"] = this.cacheKey;
        if (Array.isArray(this.antiDisableIds)) {
            data["antiDisableIds"] = [];
            for (let item of this.antiDisableIds)
                data["antiDisableIds"].push(item);
        }
        if (Array.isArray(this.serverDisableIds)) {
            data["serverDisableIds"] = [];
            for (let item of this.serverDisableIds)
                data["serverDisableIds"].push(item);
        }
        if (Array.isArray(this.toggleIds)) {
            data["toggleIds"] = [];
            for (let item of this.toggleIds)
                data["toggleIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.bundleIds)) {
            data["bundleIds"] = [];
            for (let item of this.bundleIds)
                data["bundleIds"].push(item);
        }
        if (Array.isArray(this.seriesIds)) {
            data["seriesIds"] = [];
            for (let item of this.seriesIds)
                data["seriesIds"].push(item);
        }
        data["name"] = this.name;
        data["roulette"] = this.roulette;
        data["minEfficiency"] = this.minEfficiency;
        data["minDisabled"] = this.minDisabled;
        data["maxResultCount"] = this.maxResultCount;
        data["sortColumn"] = this.sortColumn;
        data["sortDirection"] = this.sortDirection;
        return data;
    }
}

export interface IDisableListSearchInput {
    cacheKey?: number | undefined;
    antiDisableIds?: number[] | undefined;
    serverDisableIds?: number[] | undefined;
    toggleIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    bundleIds?: number[] | undefined;
    seriesIds?: number[] | undefined;
    name?: string | undefined;
    roulette?: DisableListRoulette;
    minEfficiency?: number;
    minDisabled?: number;
    maxResultCount?: number;
    sortColumn?: DisableListSortColumn;
    sortDirection?: DisableListSortDirection;
}

export class DisableListSearchResult implements IDisableListSearchResult {
    totals?: DisableListTotalsDto;
    items?: DisableListItemDto[] | undefined;

    constructor(data?: IDisableListSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totals = _data["totals"] ? DisableListTotalsDto.fromJS(_data["totals"]) : <any>undefined;
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(DisableListItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DisableListSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totals"] = this.totals ? this.totals.toJSON() : <any>undefined;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDisableListSearchResult {
    totals?: DisableListTotalsDto;
    items?: DisableListItemDto[] | undefined;
}

export class DisableListSeriesSearchResult implements IDisableListSeriesSearchResult {
    series?: DisableListItemBasicDto[] | undefined;
    notFound?: string[] | undefined;

    constructor(data?: IDisableListSeriesSearchResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["series"])) {
                this.series = [] as any;
                for (let item of _data["series"])
                    this.series!.push(DisableListItemBasicDto.fromJS(item));
            }
            if (Array.isArray(_data["notFound"])) {
                this.notFound = [] as any;
                for (let item of _data["notFound"])
                    this.notFound!.push(item);
            }
        }
    }

    static fromJS(data: any): DisableListSeriesSearchResult {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListSeriesSearchResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.series)) {
            data["series"] = [];
            for (let item of this.series)
                data["series"].push(item.toJSON());
        }
        if (Array.isArray(this.notFound)) {
            data["notFound"] = [];
            for (let item of this.notFound)
                data["notFound"].push(item);
        }
        return data;
    }
}

export interface IDisableListSeriesSearchResult {
    series?: DisableListItemBasicDto[] | undefined;
    notFound?: string[] | undefined;
}

export enum DisableListSortColumn {
    Size = 0,
    Actual = 1,
    Percent = 2,
}

export enum DisableListSortDirection {
    Ascending = 0,
    Descending = 1,
}

export class DisableListTextSearchInput implements IDisableListTextSearchInput {
    cacheKey?: number | undefined;
    text?: string | undefined;

    constructor(data?: IDisableListTextSearchInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cacheKey = _data["cacheKey"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): DisableListTextSearchInput {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListTextSearchInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cacheKey"] = this.cacheKey;
        data["text"] = this.text;
        return data;
    }
}

export interface IDisableListTextSearchInput {
    cacheKey?: number | undefined;
    text?: string | undefined;
}

export class DisableListToggleDto implements IDisableListToggleDto {
    id?: number;
    name?: string | undefined;

    constructor(data?: IDisableListToggleDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DisableListToggleDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListToggleDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IDisableListToggleDto {
    id?: number;
    name?: string | undefined;
}

export class DisableListTotalsDto implements IDisableListTotalsDto {
    totalCharacters?: number;
    totalWa?: number;
    totalHa?: number;
    totalWg?: number;
    totalHg?: number;

    constructor(data?: IDisableListTotalsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalCharacters = _data["totalCharacters"];
            this.totalWa = _data["totalWa"];
            this.totalHa = _data["totalHa"];
            this.totalWg = _data["totalWg"];
            this.totalHg = _data["totalHg"];
        }
    }

    static fromJS(data: any): DisableListTotalsDto {
        data = typeof data === 'object' ? data : {};
        let result = new DisableListTotalsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalCharacters"] = this.totalCharacters;
        data["totalWa"] = this.totalWa;
        data["totalHa"] = this.totalHa;
        data["totalWg"] = this.totalWg;
        data["totalHg"] = this.totalHg;
        return data;
    }
}

export interface IDisableListTotalsDto {
    totalCharacters?: number;
    totalWa?: number;
    totalHa?: number;
    totalWg?: number;
    totalHg?: number;
}

export class FormatListInput implements IFormatListInput {
    maxCount?: number | undefined;
    text?: string | undefined;
    itemPrefix?: string | undefined;
    itemSuffix?: string | undefined;
    minRank?: number | undefined;
    maxRank?: number | undefined;
    minKeys?: number | undefined;
    maxKeys?: number | undefined;
    minSoulkeys?: number | undefined;
    maxSoulkeys?: number | undefined;
    groupMethod?: GroupMethod;

    constructor(data?: IFormatListInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.maxCount = _data["maxCount"];
            this.text = _data["text"];
            this.itemPrefix = _data["itemPrefix"];
            this.itemSuffix = _data["itemSuffix"];
            this.minRank = _data["minRank"];
            this.maxRank = _data["maxRank"];
            this.minKeys = _data["minKeys"];
            this.maxKeys = _data["maxKeys"];
            this.minSoulkeys = _data["minSoulkeys"];
            this.maxSoulkeys = _data["maxSoulkeys"];
            this.groupMethod = _data["groupMethod"];
        }
    }

    static fromJS(data: any): FormatListInput {
        data = typeof data === 'object' ? data : {};
        let result = new FormatListInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["maxCount"] = this.maxCount;
        data["text"] = this.text;
        data["itemPrefix"] = this.itemPrefix;
        data["itemSuffix"] = this.itemSuffix;
        data["minRank"] = this.minRank;
        data["maxRank"] = this.maxRank;
        data["minKeys"] = this.minKeys;
        data["maxKeys"] = this.maxKeys;
        data["minSoulkeys"] = this.minSoulkeys;
        data["maxSoulkeys"] = this.maxSoulkeys;
        data["groupMethod"] = this.groupMethod;
        return data;
    }
}

export interface IFormatListInput {
    maxCount?: number | undefined;
    text?: string | undefined;
    itemPrefix?: string | undefined;
    itemSuffix?: string | undefined;
    minRank?: number | undefined;
    maxRank?: number | undefined;
    minKeys?: number | undefined;
    maxKeys?: number | undefined;
    minSoulkeys?: number | undefined;
    maxSoulkeys?: number | undefined;
    groupMethod?: GroupMethod;
}

export class FormatListResult implements IFormatListResult {
    totalItemCount?: number;
    itemCount?: number;
    groups?: GroupDto[] | undefined;

    constructor(data?: IFormatListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalItemCount = _data["totalItemCount"];
            this.itemCount = _data["itemCount"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(GroupDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FormatListResult {
        data = typeof data === 'object' ? data : {};
        let result = new FormatListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalItemCount"] = this.totalItemCount;
        data["itemCount"] = this.itemCount;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormatListResult {
    totalItemCount?: number;
    itemCount?: number;
    groups?: GroupDto[] | undefined;
}

export class GroupDto implements IGroupDto {
    key?: string | undefined;
    isGroup?: boolean;
    items?: string[] | undefined;

    constructor(data?: IGroupDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.key = _data["key"];
            this.isGroup = _data["isGroup"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(item);
            }
        }
    }

    static fromJS(data: any): GroupDto {
        data = typeof data === 'object' ? data : {};
        let result = new GroupDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["key"] = this.key;
        data["isGroup"] = this.isGroup;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item);
        }
        return data;
    }
}

export interface IGroupDto {
    key?: string | undefined;
    isGroup?: boolean;
    items?: string[] | undefined;
}

export enum GroupMethod {
    None = 0,
    Owner = 1,
    Note = 2,
}

export class KakeraLootsCalculateResult implements IKakeraLootsCalculateResult {
    klCount?: number;
    rolls?: string | undefined;
    wishes?: string | undefined;
    wishProtect?: string | undefined;
    overlap?: string | undefined;
    limroulA?: string | undefined;
    limroulG?: string | undefined;

    constructor(data?: IKakeraLootsCalculateResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.klCount = _data["klCount"];
            this.rolls = _data["rolls"];
            this.wishes = _data["wishes"];
            this.wishProtect = _data["wishProtect"];
            this.overlap = _data["overlap"];
            this.limroulA = _data["limroulA"];
            this.limroulG = _data["limroulG"];
        }
    }

    static fromJS(data: any): KakeraLootsCalculateResult {
        data = typeof data === 'object' ? data : {};
        let result = new KakeraLootsCalculateResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["klCount"] = this.klCount;
        data["rolls"] = this.rolls;
        data["wishes"] = this.wishes;
        data["wishProtect"] = this.wishProtect;
        data["overlap"] = this.overlap;
        data["limroulA"] = this.limroulA;
        data["limroulG"] = this.limroulG;
        return data;
    }
}

export interface IKakeraLootsCalculateResult {
    klCount?: number;
    rolls?: string | undefined;
    wishes?: string | undefined;
    wishProtect?: string | undefined;
    overlap?: string | undefined;
    limroulA?: string | undefined;
    limroulG?: string | undefined;
}

export enum KakeraLootsCalculationMode {
    Estimation = 0,
    TargetRolls = 1,
    TargetWishes = 2,
    TargetOverlap = 3,
    TargetLimroulA = 4,
    TargetLimroulG = 5,
    TargetWishProtect = 6,
}

export class KakeraLootsInput implements IKakeraLootsInput {
    mode?: KakeraLootsCalculationMode;
    target?: number;

    constructor(data?: IKakeraLootsInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.mode = _data["mode"];
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): KakeraLootsInput {
        data = typeof data === 'object' ? data : {};
        let result = new KakeraLootsInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["mode"] = this.mode;
        data["target"] = this.target;
        return data;
    }
}

export interface IKakeraLootsInput {
    mode?: KakeraLootsCalculationMode;
    target?: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}